import { forwardRef, useEffect } from 'react';
import type { LayoutAPI } from '@elfsight/widget-ui';
import {
  MasonryLayout,
  mapMasonryLayoutSettings,
  useDebounceRerender
} from '@elfsight/widget-ui';
import { useTranslation } from 'react-i18next';
import { useData } from '../../data';
import { useSocialFeedSettings } from '../../utils';
import { useLayout } from '../LayoutProvider';
import { renderPost } from '../utils';

const RERENDER_DELAY = 250;

export const Masonry = forwardRef<LayoutAPI, unknown>(
  (_props, forwardingRef) => {
    const settings = useSocialFeedSettings();
    const masonrySettings = mapMasonryLayoutSettings(settings);
    const { loadMoreButton, postTextColor } = settings;
    const dataSource = useData();
    const rerender = useDebounceRerender(RERENDER_DELAY);
    const { t } = useTranslation();

    const { setRerender } = useLayout();

    useEffect(() => {
      setRerender(rerender);
    }, [rerender, setRerender]);

    return (
      <MasonryLayout
        {...masonrySettings}
        ref={forwardingRef}
        dataSource={dataSource}
        loaderColor={postTextColor}
        // @ts-expect-error unknown не может применится для типа DataValue
        renderItem={renderPost}
        loadMoreButton={loadMoreButton}
        loadMoreButtonText={t('Load More')}
        rerender={rerender}
        withPagination
      />
    );
  }
);
